<template>
  <confirm-dialog @confirmed="removeItem">
    <template #activator="{ on, attrs }">
      <v-btn small icon color="error" class="ml-2 pl-0 pr-0" v-bind="attrs" v-on="on">
        <v-img max-width="22px" :src="require(`@/assets/delete.svg`)" />
      </v-btn>
    </template>
    <template #title>
      {{ $t("bookings-.remove") }}
    </template>
    {{ $t("bookings-.remove_question", { "clinic-name": "asdasd" }) }}
  </confirm-dialog>
</template>

<script>
import ConfirmDialog from "../components/ConfirmDialog";
import payments from "../../requests/payments";

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({}),
  methods: {
    removeItem: async function () {
      try {
        payments.destroy(this.item.id);
        await this.$store.dispatch("notificator/success", this.$t("succeeded_operation"));
        this.$emit("removed");
      } catch (e) {
        this.$store.dispatch("notificator/errorResponse", e);
      }
    },
  },
};
</script>
